import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-17-small', 'Number17Small', [["path",{"d":"M8 8h1v8"}],["path",{"d":"M13 8h4l-2 8"}]]);